exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selectModulePage__otherCategories___3S2gz > div:first-child {\n  font-size: 22px;\n  font-weight: 600;\n  color: #000000;\n  margin-top: -10px;\n  margin-bottom: 30px; }\n  @media (max-width: 576px) {\n    .selectModulePage__otherCategories___3S2gz > div:first-child {\n      font-size: 22px;\n      margin-bottom: 15px; } }\n\n.selectModulePage__otherCategories___3S2gz {\n  padding: 30px 15px 20px 15px;\n  background-color: #f9f9f9; }\n  .selectModulePage__otherCategories___3S2gz > div:first-child {\n    margin-top: 0; }\n", ""]);

// exports
exports.locals = {
	"otherCategories": "selectModulePage__otherCategories___3S2gz"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/SelectModulePage/styles/selectModulePage.scss
// module id = 5066
// module chunks = 6